import React from 'react';
import { Tab, Tabs, Table } from 'react-bootstrap';

const CommentaryComponent = ({ meta, ballByBall, scorer }) => {
  return (
    <div id="commentary">
      <div className="row">
        <div id="commentary-tabs">
          <Tabs className="tab-wrapper">
            <Tab eventKey="inning-1-commentary-tab" title="1st Inning">
              <div id="inning-1-commentary-tab-content" className="commentary-content">
                {Object.keys(ballByBall.inn1.overs).map((over, overIndex) => (
                  <div key={overIndex} className="commentary-block">
                    <Table className="commentary-events">
                      <tbody>
                        {ballByBall.inn1.overs[over].coverage.map((event, eventIndex) => (
                          <tr key={eventIndex} className={event.type === 'comment' ? (event.powerplay ? 'comment powerplay' : 'comment') : (event.powerplay ? 'powerplay' : '')}>
                            {event.type === 'comment' ? (
                              <td colSpan="2" className="ball-commentary">{event.c}</td>
                            ) : (
                              <>
                                <td className="commentary-over">
                                  {event.o}
                                  <div>
                                    <span className={`runs runs-${event.type}`} dangerouslySetInnerHTML={{__html:event.r}}></span>
                                  </div>
                                </td>
                                <td className="ball-commentary" dangerouslySetInnerHTML={{__html:event.c}}></td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {ballByBall.inn1.overs[over].summary.end && (
                      <div className={`end-of-over-info${ballByBall.inn1.overs[over].summary.powerplay ? ' powerplay' : ''}`}>
                        <Table className="end-of-over-player-stat">
                          <tbody>
                            <tr>
                              <td colSpan="4">
                                <span className="bold">{ballByBall.inn1.overs[over].summary.endofmatch ? 'End of Match' : `End of Over ${ballByBall.inn1.overs[over].summary.ov}${ballByBall.inn1.overs[over].summary.powerplay ? ' (Powerplay)' : ''}`} </span> ({ballByBall.inn1.overs[over].summary.r} runs, {ballByBall.inn1.overs[over].summary.w} wickets)
                                <span className="bold"> {ballByBall.inn1.overs[over].summary.tm} {ballByBall.inn1.overs[over].summary.sc}</span>
                              </td>
                            </tr>
                            {ballByBall.inn1.overs[over].summary.eq && (
                              <tr>
                                <td colSpan="4">{ballByBall.inn1.overs[over].summary.eq}</td>
                              </tr>
                            )}
                            <tr>
                              <td className="over-stat-name">{ballByBall.inn1.overs[over].summary.on.name}</td>
                              <td className="over-stat-score">{ballByBall.inn1.overs[over].summary.on.stat}</td>
                              <td className="over-stat-name">{ballByBall.inn1.overs[over].summary.bowl.name}</td>
                              <td className="over-stat-score">{ballByBall.inn1.overs[over].summary.bowl.stat}</td>
                            </tr>
                            <tr>
                              <td className="over-stat-name">{ballByBall.inn1.overs[over].summary.off.name}</td>
                              <td className="over-stat-score">{ballByBall.inn1.overs[over].summary.off.stat}</td>
                              <td className="over-stat-name"></td>
                              <td className="over-stat-score"></td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </Tab>
            <Tab eventKey="inning-2-commentary-tab" title="2nd Inning">
              <div id="inning-2-commentary-tab-content" className="commentary-content">
              {Object.keys(ballByBall.inn2.overs).map((over, overIndex) => (
                  <div key={overIndex} className="commentary-block">
                    <Table className="commentary-events">
                      <tbody>
                        {ballByBall.inn2.overs[over].coverage.map((event, eventIndex) => (
                          <tr key={eventIndex} className={event.type === 'comment' ? (event.powerplay ? 'comment powerplay' : 'comment') : (event.powerplay ? 'powerplay' : '')}>
                            {event.type === 'comment' ? (
                              <td colSpan="2" className="ball-commentary">{event.c}</td>
                            ) : (
                              <>
                                <td className="commentary-over">
                                  {event.o}
                                  <div>
                                    <span className={`runs runs-${event.type}`}>{event.r}</span>
                                  </div>
                                </td>
                                <td className="ball-commentary">{event.c}</td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {ballByBall.inn2.overs[over].summary.end && (
                      <div className={`end-of-over-info${ballByBall.inn2.overs[over].summary.powerplay ? ' powerplay' : ''}`}>
                        <Table className="end-of-over-player-stat">
                          <tbody>
                            <tr>
                              <td colSpan="4">
                                <span className="bold">{ballByBall.inn2.overs[over].summary.endofmatch ? 'End of Match' : `End of Over ${ballByBall.inn2.overs[over].summary.ov}${ballByBall.inn1.overs[over].summary.powerplay ? ' (Powerplay)' : ''}`} </span> ({ballByBall.inn2.overs[over].summary.r} runs, {ballByBall.inn2.overs[over].summary.w} wickets)
                                <span className="bold"> {ballByBall.inn2.overs[over].summary.tm} {ballByBall.inn1.overs[over].summary.sc}</span>
                              </td>
                            </tr>
                            {ballByBall.inn2.overs[over].summary.eq && (
                              <tr>
                                <td colSpan="4">{ballByBall.inn2.overs[over].summary.eq}</td>
                              </tr>
                            )}
                            <tr>
                              <td className="over-stat-name">{ballByBall.inn2.overs[over].summary.on.name}</td>
                              <td className="over-stat-score">{ballByBall.inn2.overs[over].summary.on.stat}</td>
                              <td className="over-stat-name">{ballByBall.inn2.overs[over].summary.bowl.name}</td>
                              <td className="over-stat-score">{ballByBall.inn2.overs[over].summary.bowl.stat}</td>
                            </tr>
                            <tr>
                              <td className="over-stat-name">{ballByBall.inn2.overs[over].summary.off.name}</td>
                              <td className="over-stat-score">{ballByBall.inn2.overs[over].summary.off.stat}</td>
                              <td className="over-stat-name"></td>
                              <td className="over-stat-score"></td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </Tab>
            {meta.inn === '4' && (
              <>
                <Tab eventKey="inning-3-commentary-tab" title="3rd Inning">
                  <div id="inning-3-commentary-tab-content" className="commentary-content">
                    {/* Render content for the third inning if needed */}
                  </div>
                </Tab>
                <Tab eventKey="inning-4-commentary-tab" title="4th Inning">
                  <div id="inning-4-commentary-tab-content" className="commentary-content">
                    {/* Render content for the fourth inning if needed */}
                  </div>
                </Tab>
              </>
            )}
          </Tabs>
        </div>
        <div className="commentator-scorer">
          <p className="cs-commentator">
            <strong>Scorer and Commentator </strong> : {scorer}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommentaryComponent;
